import React from 'react'
import "./connect.css"

const Connect = () => {
  return (
    <div className='connect'>
      <div className="connectItem">
        <img src="https://cf.bstatic.com/static/img/communities/cover-photo/300x300/india/a047bf294ce2d2e145fdcdd3097b9a7f4e6df229.jpg" alt="" className="conectIMg" />
        <h1>India</h1>
        <span>Travel community</span>
        <span>155,073 travelers</span>
      </div>


      <div className="connectItem">
        <img src="https://cf.bstatic.com/static/img/communities/cover-photo/300x300/india/a047bf294ce2d2e145fdcdd3097b9a7f4e6df229.jpg" alt="" className="conectIMg" />
        <h1>India</h1>
        <span>Travel community</span>
        <span>155,073 travelers</span>
      </div>


      <div className="connectItem">
        <img src="https://cf.bstatic.com/static/img/communities/cover-photo/300x300/india/a047bf294ce2d2e145fdcdd3097b9a7f4e6df229.jpg" alt="" className="conectIMg" />
        <h1>India</h1>
        <span>Travel community</span>
        <span>155,073 travelers</span>
      </div>

      <div className="connectItem">
        <img src="https://cf.bstatic.com/static/img/communities/cover-photo/300x300/india/a047bf294ce2d2e145fdcdd3097b9a7f4e6df229.jpg" alt="" className="conectIMg" />
        <h1>India</h1>
        <span>Travel community</span>
        <span>155,073 travelers</span>
      </div>
    </div>
  )
}

export default Connect
